import { useTranslation } from 'next-i18next'
import React from 'react'

import { useFeedbackStore } from '../../../functions/store'
import RatingLabel from '../ratingLabel'
import { AreaTitle } from './areaTitle'

const GameStyleSlider = ({ fighter, index }) => {
  const store = useFeedbackStore((state) => state)
  const { moveSlider } = store.feedbackActions
  const { t } = useTranslation('avaliacao360')

  // Getting the current game style points for the current fighter
  const gameStylePoints = store.ratings[index].gameStyle

  const sliderHandler = (e) => {
    const { value } = e.target
    const numberValue = parseInt(value)
    moveSlider(fighter, numberValue)
  }

  return (
    <div className="w-full mb-8 group bg-white p-3 md:p-4 rounded-xl">
      <AreaTitle title={t('gameStyle.title')} />
      <div>
        <input
          type="range"
          min="1"
          max="100"
          value={gameStylePoints}
          className="slider"
          onChange={sliderHandler}
        />
        <div className="flex flex-row justify-between -mt-4">
          <RatingLabel text={t('gameStyle.guardPlayer')} />
          <RatingLabel text={t('gameStyle.passer')} />
        </div>
      </div>
    </div>
  )
}

export default GameStyleSlider
